import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { NormalizedProduct } from 'utils/useMapProducts';
import { sendUIEvent } from 'services/analytics';
import { SCREEN_NAME } from 'constants/index';
import { formatUrlForDisplay } from 'utils';

export const Products = ({
  products,
  source,
  isPersonalView,
}: {
  products: NormalizedProduct[];
  source: SCREEN_NAME;
  isPersonalView: boolean;
}) => {
  const filteredProducts = products.filter(
    (product) =>
      product?.title?.toLowerCase() !== 'community announcements'.toLowerCase(),
  );
  const onClickProduct = (productId: string, url?: string) => {
    sendUIEvent({
      source,
      action: 'clicked',
      actionSubject: 'pill',
      actionSubjectId: 'productPill',
      attributes: {
        productId,
      },
      isPersonalView,
    });
    if (url) {
      window.open(
        formatUrlForDisplay(process.env.REACT_APP_COMMUNITY_BASE_URL + url),
      );
    }
  };
  return filteredProducts.length ? (
    <div data-testid="products-container" css={productsContainerStyles}>
      {filteredProducts.map((product) => (
        <a
          key={product.id}
          data-testid={`product-${product.id}`}
          onClick={() => onClickProduct(product.id, product.viewHref ?? '')}
          role="link"
          target="_blank"
          rel="noopener noreferrer nofollow"
          css={[productPillStyles, productNameStyles]}
        >
          {product.title}
        </a>
      ))}
    </div>
  ) : null;
};

// Adding negative margin to counteract the bottom margin of the last product pill
const productsContainerStyles = css({
  marginBottom: `calc(0px - ${token('space.150')})`,
});

const productPillStyles = css({
  cursor: 'pointer',
  backgroundColor: token('color.background.input.hovered'),
  border: `1px solid ${token('color.border')}`,
  borderRadius: '56px',
  padding: `${token('space.100')} ${token('space.150')}`,
  display: 'inline-block',
  marginRight: token('space.100'),
  marginBottom: token('space.150'),
  '&:hover': {
    border: `1px solid ${token('color.border.accent.gray')}`,
    textDecoration: 'none',
    color: 'inherit',
  },
  '&:active': {
    border: `1px solid ${token('color.border.selected')}`,
  },
});

const productNameStyles = css({
  fontWeight: token('font.weight.semibold'),
  lineHeight: '18px',
  fontFamily: token('font.family.brand.body'),
  textTransform: 'uppercase',
  fontSize: '14px',
  textDecoration: 'none',
  color: token('color.text'),
});
